import { useCallback, useEffect, useState } from "react";

export function useBanner() {
  const [isMobile, setIsMobile] = useState(false);
  const [numColumns, setNumColumns] = useState(3);
  const [fadeIndexes, setFadeIndexes] = useState([]);

  const updateDisplayedCols = useCallback(() => {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1200) return setNumColumns(9);
    if (screenWidth >= 992) return setNumColumns(8);
    if (screenWidth >= 768) return setNumColumns(7);
    if (screenWidth >= 576) return setNumColumns(5);
    setNumColumns(3);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", updateDisplayedCols);
    updateDisplayedCols();
    return () => {
      window.removeEventListener("resize", updateDisplayedCols);
    };
  }, [updateDisplayedCols]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    state: { fadeIndexes, numColumns, isMobile },
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default () => null;
